export const UI_SETTINGS_CHANGED = 'SETTINGS_UI_SETTINGS_CHANGED'
export const FORGET_ALL = 'SETTINGS_FORGET_ALL_PINNED_USERS'



// WEBPACK FOOTER //
// ./src/features/Settings/data/constants.js